export const DATA_SEARCHER = 'DATA_SEARCHER';

export const setDataSearch = (payload) => (dispatch) => {
    dispatch({
        type: DATA_SEARCHER,
        payload,
    });
};



// WEBPACK FOOTER //
// ./src/actions/searcher.js